/*
 * Copyright (c) 2023. IOWEB TECHNOLOGIES
 */

import $ from 'jquery';

$(document).ready(function () {
    let $body = $('body');
    if ($body.length > 0 && $body[0].id !== 'product') {
        console.log('product-scroll.js: not on product page');
        return;
    }
    console.log('product-scroll.js');
    let $productScroll = $('ul.product-images.js-qv-product-images');
    let countImages = $productScroll.children().length;
    let $up = $('#product-images-cont .up');
    let $down = $('#product-images-cont .down');

    if ($productScroll.length > 0 && countImages > 4) {
        let index = 0;
        let imageHeight = $productScroll.children().first().height() + 10;
        let scrollBy = 4;
        let scrollHeight = scrollBy * imageHeight;
        $up.click(function () {
            console.log(index);
            if (index > 0) {
                $productScroll.animate({marginTop: '+=' + scrollHeight + 'px'}, 200);
                index = index - scrollBy;
            }
        });
        $down.click(function () {
            console.log(index);
            if (index < (countImages - scrollBy)) {
                $productScroll.animate({marginTop: '-=' + scrollHeight + 'px'}, 200);
                index = index + scrollBy;
            }
        });
    }

    $('#product #main #content .product-images .thumb-container img').on('tap', function (event) {
       $(event.currentTarget).trigger('click');
    });


});